import { Icon } from "semantic-ui-react";

type InfoColumnProps = {
  label?: string;
  value: string;
  icon: "hashtag" | "clock" | "calendar";
};

export const InfoColumn = ({ label, value, icon }: InfoColumnProps) => {
  return (
    <div className="appointment-info__column">
      {label && <span className="appointment-info__label">{label}</span>}
      <Icon className={icon} />
      <span className="appointment-info__value">{value}</span>
    </div>
  );
};
